import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner, Box } from '@chakra-ui/react';

/**
 * This route wrapper protects EOS admin pages.
 * It grants access ONLY if the user has BOTH:
 * - 'SuperAdmin: true' AND
 * - 'isEOSUser: true'
 * 
 * This ensures that even SuperAdmins must have EOS access enabled
 * to access EOS admin routes like /eos/admin
 */
const EOSSuperAdminRoute = ({ children, ...rest }) => {
  const { currentUser, SuperAdmin, loading } = useAuth();

  if (loading) {
    return (
      <Box w="100%" h="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <Route
      {...rest}
      render={({ location }) => {
        // Check for BOTH SuperAdmin AND isEOSUser
        const isSuperAdmin = currentUser && (currentUser.SuperAdmin === true || SuperAdmin === true);
        const hasEOSAccess = currentUser && currentUser.isEOSUser === true;
        
        if (isSuperAdmin && hasEOSAccess) {
          return (
            <Box
              transform="scale(0.9)"
              transformOrigin="top left"
              w="111.11%"
              sx={{
                '& > .chakra-container': {
                  maxWidth: '100%',
                },
              }}
            >
              {children}
            </Box>
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: '/', // Redirect to dashboard
                state: { from: location },
              }}
            />
          );
        }
      }}
    />
  );
};

export default EOSSuperAdminRoute;
